import classNames from 'classnames';
import { FC, useCallback, useMemo } from 'react';
import { ITabPickerProps } from '../../TabPicker';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import './style.scss';

interface IProps extends ITabPickerProps {
  tab: IPickerOption;
}

const TabPickerTab: FC<IProps> = ({ tab, ...props }: IProps): JSX.Element => {
  const onTabSelect = useCallback(() => {
    if (props.disabled) return;
    props.onChange(tab.value);
  }, [props.disabled, tab.value]);

  const isActive = useMemo((): boolean => {
    return props.value === tab.value;
  }, [props.value, tab]);

  const tabClassName = useMemo((): string => {
    return classNames('tab-picker__tab', { disabled: props.disabled, 'tab-picker__tab_active': isActive }, props.tabClassName);
  }, [props.disabled, isActive, props.tabClassName]);

  return (
    <div key={tab.value} onClick={onTabSelect} className={tabClassName}>
      <span className="tab-picker__tab-title">{props.noLabelTranslate ? tab.label : localeStore.t(tab.label)}</span>
    </div>
  );
};

export default TabPickerTab;
